// favorites.js — PUBLIC Favorites (wishlist) island.
//
// Renders the visitor's saved rugs on /pages/favorites entirely IN-PAGE. State
// is the SAME site-wide wishlist every heart uses: localStorage key
// 'arteverk_favs', an array of BARE-NUMERIC product ids (e.g. "7365007999116").
// We load the public CDN rug feed, look up each saved id, and rebuild the
// matches as the site's own product cards (.card / .cards — global theme.css
// styles them verbatim) at RETAIL price, hearts pre-FILLED (these are all
// favourited). Removing a heart mutates the SAME key + the SAME nav count badge
// theme.js uses, so the page stays in lockstep with hearts everywhere else and
// the nav heart's count. No login, no server, no OPS endpoint — the retail-feed
// twin of rug-finder.js.
(function () {
  var root = document.querySelector('[data-favs]');
  if (!root) return;
  var grid = root.querySelector('[data-favs-grid]');
  var empty = root.querySelector('[data-favs-empty]');
  var emptyLead = root.querySelector('[data-favs-empty-lead]');
  if (!grid || !empty) return;

  // ── Site-wide favourites store — identical contract to theme.js (section 4)
  // and rug-finder.js: same KEY, same bare-numeric ids, same nav-count badge
  // behaviour (hidden when 0). This is what keeps the page, the hearts on every
  // other surface, and the nav badge as ONE wishlist. ──────────────────────────
  var FAV_KEY = 'arteverk_favs';
  var readFavs = function () { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } };
  var writeFavs = function (arr) { try { localStorage.setItem(FAV_KEY, JSON.stringify(arr)); } catch (e) {} };
  var navFav = document.querySelector('[data-fav-nav]');
  var navCount = document.querySelector('[data-fav-count]');
  // Mirror theme.js paintCount() exactly: badge text = count, hidden when 0,
  // nav heart gets the .has class when non-empty.
  function paintFavCount() {
    var n = readFavs().length;
    if (navCount) { navCount.textContent = n; navCount.hidden = n === 0; }
    if (navFav) navFav.classList.toggle('has', n > 0);
  }

  // ── Render helpers (mirror rug-finder.js / trade-concierge.js) ───────────────
  var money = function (c) { return c == null ? '' : '$' + (c / 100).toLocaleString('en-US', { maximumFractionDigits: 0 }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };
  var imgAt = function (url, w) { return url ? url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w : ''; };

  // ── Pointer-aware feed load (copied from rug-finder.js loadFeed). Resolves to
  // an array of rug rows. The feed asset may itself be a POINTER ({ url }) to the
  // real CDN feed, or carry the rugs inline ({ rugs }). ────────────────────────
  var feedPromise = null;
  function loadFeed() {
    if (!feedPromise) {
      feedPromise = fetch(root.dataset.feed)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (Array.isArray(d.rugs)) return d.rugs;
          if (d.url) return fetch(d.url).then(function (r) { return r.json(); }).then(function (f) { return f.rugs || []; });
          return [];
        })
        .catch(function () { return []; });
    }
    return feedPromise;
  }
  function track(event, params) {
    if (window.gtag) window.gtag('event', event, Object.assign({ method: 'favorites' }, params || {}));
  }

  // The feed gives shopify_product_id as a GID (gid://shopify/Product/123…), but
  // 'arteverk_favs' holds the BARE numeric id ({{ p.id }} in product-card.liquid).
  // The numeric tail of the GID is that bare id — so we match by tail. (Same idea
  // as rug-finder.js favId(), inverted: there we strip the GID to STORE; here we
  // take the tail to FIND.)
  var gidTail = function (gid) { return String(gid == null ? '' : gid).split('/').pop(); };

  // ── The site product card, rebuilt in JS to mirror snippets/product-card.liquid
  // (and rug-finder.js cardHTML). RETAIL price only (rug.price_cents). The heart
  // is the site's own (.card-fav + data-fav-id/data-fav-name), pre-rendered in the
  // FILLED/.saved state because every card here is already favourited. Same
  // classes/DOM so global theme.css styles it identically. ─────────────────────
  function cardHTML(rug) {
    var name = rug.rug_name || rug.title || '';
    var hasName = !!(rug.rug_name && rug.title && rug.rug_name !== rug.title);
    var eyebrow = (rug.styles && rug.styles.length ? rug.styles[0] : rug.origin) || '';
    var url = rug.product_url || (rug.handle ? '/products/' + rug.handle : '#');
    var img = rug.image_url
      ? '<img class="base" src="' + esc(imgAt(rug.image_url, 600)) + '" srcset="' + esc(imgAt(rug.image_url, 600)) + ' 600w, ' + esc(imgAt(rug.image_url, 900)) + ' 900w" sizes="(max-width:520px) 92vw, (max-width:880px) 45vw, 30vw" alt="' + esc(name) + '" loading="lazy" width="600" height="750">'
      : '';
    var badges = '';
    if (rug.is_ooak) badges += '<span class="badge ooak"><span class="mk" aria-hidden="true">&#9670;</span>1 of 1</span>';
    if (rug.masterpiece) badges += '<span class="badge master"><span class="mk" aria-hidden="true">&#9670;</span>Masterpiece</span>';
    var price = rug.price_cents != null ? money(rug.price_cents) : 'Price on request';
    var fid = gidTail(rug.shopify_product_id);
    // .card-fav is a SIBLING of the card-wide <a> (an interactive control must
    // never nest inside an anchor — matches product-card.liquid). Pre-filled:
    // .saved + aria-pressed="true". Clicking REMOVES it from the wishlist.
    var fav = '<button class="card-fav saved" type="button" data-fav-id="' + esc(fid) + '" data-fav-name="' + esc(name) + '" aria-pressed="true" aria-label="Remove ' + esc(name) + ' from your favorites"><span class="ch" aria-hidden="true">&#9825;</span></button>';
    return '<article class="card reveal in" data-fav-card="' + esc(fid) + '">' +
      fav +
      '<a class="card-core" href="' + esc(url) + '" aria-label="' + esc(name) + (hasName ? ' — ' + esc(rug.title) : '') + '">' +
        '<div class="card-img">' + badges + img + '</div>' +
        '<div class="card-body">' +
          (eyebrow ? '<div class="card-collection">' + esc(eyebrow) + '</div>' : '') +
          '<h3 class="card-name">' + esc(name) + '</h3>' +
          (hasName ? '<div class="card-descriptor">' + esc(rug.title) + '</div>' : '') +
          '<div class="card-foot"><div class="card-price">' + price + '</div></div>' +
        '</div>' +
      '</a>' +
    '</article>';
  }

  // Show/hide grid vs empty state. `gentle` swaps the copy for the case where the
  // visitor HAS saved ids but none of them resolve in the feed (sold / removed).
  function showEmpty(gentle) {
    grid.hidden = true;
    empty.hidden = false;
    if (gentle && emptyLead) {
      emptyLead.textContent = 'The pieces you saved are no longer available — they may have found a home. Discover something new below.';
    }
  }
  function showGrid() { empty.hidden = true; grid.hidden = false; }

  // ── Initial render ───────────────────────────────────────────────────────────
  paintFavCount();
  var savedIds = readFavs();
  if (!savedIds.length) { showEmpty(false); return; }

  loadFeed().then(function (feed) {
    // Index the feed by bare-numeric id for O(1) lookup.
    var byId = {};
    for (var k = 0; k < feed.length; k++) {
      var r = feed[k];
      byId[gidTail(r.shopify_product_id)] = r;
    }
    // Preserve SAVED order, most-recent first (arteverk_favs appends on add, so
    // the last entry is the newest). Skip ids with no feed match silently.
    var ordered = savedIds.slice().reverse();
    var matched = [];
    for (var j = 0; j < ordered.length; j++) {
      var rug = byId[ordered[j]];
      if (rug) matched.push(rug);
    }
    if (!matched.length) { showEmpty(true); return; }
    showGrid();
    grid.innerHTML = matched.map(cardHTML).join('');
    track('view_favorites', { count: matched.length });
  });

  // ── Remove-heart: ONE delegated handler. Clicking a card's heart removes that
  // id from the wishlist, updates the nav count (theme.js's exact logic), and
  // drops the card from the grid — revealing the empty state if it was the last.
  // ─────────────────────────────────────────────────────────────────────────────
  grid.addEventListener('click', function (e) {
    var favBtn = e.target.closest('.card-fav[data-fav-id]');
    if (!favBtn) {
      // Let a click on the card body navigate normally.
      if (e.target.closest('.card-core')) track('favorites_card_click');
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    var id = favBtn.dataset.favId;
    var favs = readFavs().filter(function (x) { return x !== id; });
    writeFavs(favs);
    paintFavCount();
    var card = favBtn.closest('[data-fav-card]') || favBtn.closest('.card');
    if (card) card.remove();
    track('remove_favorite', { item_id: id, item_name: favBtn.dataset.favName || '' });
    // If that was the last card, fall back to the empty state.
    if (!grid.querySelector('.card')) showEmpty(false);
  });
})();
